import React, { Component } from "react"
import { Redirect, Link } from "react-router-dom"
import { Helmet } from "react-helmet"
import LoginForm from "../../components/Login"
import ForgotPassword from "../../components/ForgotPassword"
import ActivateAccount from "../../components/ActivateAccount"
import qs from "qs"

import "./login.scss"

class Login extends Component {
  constructor(props) {
    super(props)

    this.state = {
      redirectTo: null,
      forgotPassword: false,
      showETS: false,
      isModalOpen: false,
      email: "",
    }
  }

  static getDerivedStateFromProps = (props, state) => {
    let query = qs.parse(props.location.search, { ignoreQueryPrefix: true })

    return {
      ...state,
      forgotPassword: query.forgotPassword === "true" || false,
    }
  }

  toggleForgotPassword = () => {
    this.props.history.replace({
      ...this.props.location,
      search: qs.stringify(
        { forgotPassword: !this.state.forgotPassword || undefined },
        { addQueryPrefix: true }
      ),
    })
  }

  toggleModal = () => {
    let isModalOpen = !this.state.isModalOpen
    this.setState({ isModalOpen })
  }

  onEmailChange = (e) => {
    this.setState({ email: e.target.value })
  }

  onLoginSuccess = () => {
    let { from } = this.props.location.state || { from: { pathname: "/" } }

    let redirectTo = from || "/"
    this.setState({ redirectTo })
  }

  onForgotPasswordSuccess = () => {
    this.props.history.push("/")
  }

  componentDidMount() {
    this.setState({
      showETS:
        this.props.location.state &&
        this.props.location.state.from.pathname ===
          "/ets/survey-highlights/10kview"
          ? true
          : false,
    })
  }

  render() {
    let { redirectTo, forgotPassword } = this.state

    if (redirectTo) {
      return <Redirect to={redirectTo} />
    }

    return (
      <div id="login-page">
        <Helmet>
          <title>{forgotPassword ? "Forgot Password" : "Login"}</title>
        </Helmet>
        <div
          className={
            this.state.showETS
              ? "login-form-container login-form-cols"
              : "login-form-container "
          }
        >
          {forgotPassword ? (
            <ForgotPassword
              onSuccess={this.onForgotPasswordSuccess}
              login={this.toggleForgotPassword}
            />
          ) : (
            <LoginForm
              onSuccess={this.onLoginSuccess}
              forgotPassword={this.toggleForgotPassword}
              bigLogo={true}
              {...this.props}
            />
          )}
          {this.state.showETS && (
            <div className="ets-login">
              <h3 className="ets-login__header">Don’t Know What ETS Is?</h3>
              <p className="ets-login__text">
                The <strong>Emerging Technology Study</strong> is not only
                capturing the enterprise’s appetite for emerging technology
                vendors across the global market...
              </p>
              <div className="ets-image__container">
                <img
                  className="ets-login__image"
                  src="https://s3.amazonaws.com/prod-etr/uploads/images/ets-login--image.png"
                />
              </div>
              <Link className="btn primary" to="/ets">
                Learn About ETS
              </Link>
            </div>
          )}
        </div>
        <ActivateAccount />
      </div>
    )
  }
}

export default Login
